/**
 * Country calling-code helpers for customer/staff phone fields.
 * UI shows dial code as a prepend; DB stores full E.164 (e.g. +447475352330).
 */

export function formatDialCode(raw) {
  if (!raw || typeof raw !== "string") return "";
  const trimmed = raw.trim();
  if (!trimmed) return "";
  return trimmed.startsWith("+") ? trimmed : `+${trimmed}`;
}

/**
 * Build E.164 from a local input (or already-full number) + company dial code.
 * Strips spaces/punctuation and a leading national 0 (e.g. 07475… → +447475…).
 */
export function toE164Phone(localOrFull, dialCode) {
  const raw = (localOrFull ?? "").toString().trim();
  if (!raw) return "";

  const dial = formatDialCode(dialCode);

  if (raw.startsWith("+")) {
    const digits = raw.slice(1).replace(/\D/g, "");
    return digits ? `+${digits}` : "";
  }

  let localDigits = raw.replace(/\D/g, "");
  if (!localDigits) return "";

  if (localDigits.startsWith("0")) {
    localDigits = localDigits.replace(/^0+/, "");
  }
  if (!localDigits) return "";

  if (dial) {
    const dialDigits = dial.slice(1);
    if (localDigits.startsWith(dialDigits)) {
      return `+${localDigits}`;
    }
    return `${dial}${localDigits}`;
  }

  return `+${localDigits}`;
}

/**
 * Strip company dial code from a stored E.164 value for the local input field.
 */
export function toLocalPhoneForInput(fullPhone, dialCode) {
  const raw = (fullPhone ?? "").toString().trim();
  if (!raw) return "";

  const dial = formatDialCode(dialCode);
  const digits = raw.replace(/\D/g, "");

  if (dial) {
    const dialDigits = dial.slice(1);
    if (raw.startsWith(dial) || digits.startsWith(dialDigits)) {
      const local = digits.startsWith(dialDigits)
        ? digits.slice(dialDigits.length)
        : digits;
      return local;
    }
  }

  if (raw.startsWith("+")) {
    return digits;
  }

  return digits.replace(/^0+/, "") || digits;
}
